import { createLocalTracks } from 'twilio-video'

export const twilioMixin = {
  methods: {
    async applyInputDevice(kind, deviceId, localTracks, render) {
      // Create a new LocalTrack from the given Device ID.
      const [track] = await createLocalTracks({ [kind]: { deviceId } })

      // Stop the previous LocalTrack, if present.
      if (localTracks[kind]) {
        localTracks[kind].stop()
      }

      // Render the current LocalTrack.
      localTracks[kind] = track
      render(new MediaStream([track.mediaStreamTrack]))
    },

    saveNewDevice(kind, deviceId) {
      localStorage.setItem(`${kind}DeviceId`, deviceId)
      this.$store.commit('CHANGE_DEVICE_ID', { kind: kind, deviceId: deviceId })
    },

    async getInputDevices(kind) {
      const devices = await navigator.mediaDevices.enumerateDevices()
      return devices.filter(device => device.kind === `${kind}input`)
    }
  }
}
